<template>
<ul class="row">
  <!-- {{sellpoints}}
     -->
  <li class="col-md-6" v-for="sp in sellpoints" :key="sp.business_id"> 
    <article> <img class="img-responsive" src="static/assets/images/new-ar-img-1.jpg" alt="">
      <div class="sp-business-card">
        <p>{{sp.business_name}}</p>
        <p>Block 1B 2-face street AddisA Laos</p>
        <a :href="'points?pg='+sp.business_url_name" class="btn btn-small btn-round">View my sellpoint</a>
      </div>
    </article>
  </li>
</ul>
  
</template>

<script>
  //import ProductItem from './ProductItem.vue'
  export default {
    name: 'sellpoint-list',
    created () {
      if (this.sellpoints.length === 0) {
        this.$store.dispatch('allSellpoints')
      }
    },
    computed: {
      sellpoints () {
       //return this.$store.getters.allSellpoints
       let data = this.$store.getters.allSellpoints
       if(data.status == 200) {
          return data.data;
        }
      }
    },
    data () {
      return {

      }
    },
    // components: {
    //   'product-item': ProductItem
    // }
  }
</script>


// WEBPACK FOOTER //
// SellpointList.vue?94b6036a